import dark from "./dark"
import light from "./light"

const gradients = {
  light,
  dark,
}

export default gradients
